<template>
  <div class="choropleth">
    <div class="mapWrapper">
        <svg width="100%" :height="height" ref="svg">
          <g class="map">
            <path v-for="(polygon, index) in polygons" 
              v-bind:key="'polygon'+index"
              class="polygon" 
              :d="polygon.path"
            >
            </path>            
          </g>
          <g class="map" v-if="markers">
            <g v-for="marker in markers" :key="marker.label">
              <text 
                :y="project([marker.lat, marker.long])[1]-7" 
                :x="project([marker.lat, marker.long])[0]" 
                :text-anchor="marker.anchor||'middle'"
                class="marker shaddow"
                :stroke-width="2"
                :font-size="14"
              >
                {{marker.label}}
              </text>
              <text 
                :y="project([marker.lat, marker.long])[1]-7" 
                :x="project([marker.lat, marker.long])[0]" 
                :text-anchor="marker.anchor||'middle'"
                class="marker"
                :font-size="14"
              >
                {{marker.label}}
              </text>
              <circle 
                class="marker-dot"
                :cx="project([marker.lat, marker.long])[0]" 
                :cy="project([marker.lat, marker.long])[1]" 
                :r="3"
              />
            </g>
          </g>
        </svg>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import debounce from 'debounce'
// import SvgPanZoom from 'vue-svg-pan-zoom'

// import BarChart from './BarChart.vue'

d3.formatDefaultLocale({
  'decimal': ',',
  'thousands': '.',
  'grouping': [3],
  'currency': ['', '€'],
  'dateTime': '%a %b %e %X %Y',
  'date': '%d.%m.%Y',
  'time': '%H:%M:%S',
  'periods': ['AM', 'PM'],
  'days': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  'shortDays': ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  'months': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  'shortMonths': ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
})

export default {
  name: 'LocatorMap',
  components: {
  },
  props: {
    options: Object,
    geoJson: Object,
    markers: Array,
    maxHeight: {
      type: Number,
      default: 700
    },
    value: Object,
  },
  data () {
    return {
      projection: d3.geoMercator(),
      polygons: [],
      height: this.maxHeight,
      width: 600,
      hover: null,
      strokeWidth: 1.0,
      defaultOptions: {
        title:"Stärkste Partei",
        type:"heatmap",
        regionKey:"WKR_NR",
        regionLabel:"WKR_NAME",
        colors:[{"label":"SPD","id":"SPD","color":"#c51d1e"},{"label":"CDU","id":"CDU","color":"#333"},{"label":"CSU","id":"CSU","color":"#333"},{"label":"Grüne","id":"GRÜNE","color":"#0c9941"},{"label":"FDP","id":"FDP","color":"#f6c909"},{"label":"AfD","id":"AfD","color":"#2b7ab4"},{"label":"Linke","id":"DIE LINKE","color":"#bb4894"},{"label":"Die PARTEI","id":"Die PARTEI","color":"#B92837"},{"label":"FW","id":"FREIE WÄHLER","color":"#b5b9bc"},{"label":"Piraten","id":"PIRATEN","color":"#f39200"},{"label":"REP","id":"REP","color":"#a07e26"},{"label":"NPD","id":"NPD","color":"#a07e26"},{"label":"Einheit","id":"EINHEIT","color":"#a284c7"},{"label":"Volt","id":"Volt","color":"#502379"},{"label":"Humanisten","id":"HUMANISTEN","color":"#d90368"},{"label":"DKP","id":"DKP","color":"red"}],
        colorScale:['#fff', '#111'],
        // suffix:"%",
        legend:true,
        zoom: true
      }
    }
  },
  methods: {
    fitProjection () {
      this.width = this.$refs.svg.getBoundingClientRect().width
      let height = this.maxHeight

      this.projection.scale(1).translate([0, 0])
      var b = this.path.bounds(this.geoJson)
      var s = 1 / Math.max((b[1][0] - b[0][0]) / this.width, (b[1][1] - b[0][1]) / height)

      this.height = (b[1][1] - b[0][1]) * s
      // console.log(this.width, this.height)

      var t = [(this.width - s * (b[1][0] + b[0][0])) / 2, (this.height - s * (b[1][1] + b[0][1])) / 2]

      this.projection
        .scale(s)
        .translate(t)

      this.polygons = this.geoJson.features.map(f => {
        return {
          path: this.path(f),
          feature: f
        }
      })
    },
    project (array) {
      return this.projection(array)
    },
    format (num) {
      return String(num).replace('.',',')
    },
    getColor( value ) {
      return this.colorScale(value*12)
    },
    getFill (polygon) {
      // console.log('getfill')
      // return '#ddd'
      let color = '#ddd'
      
      if (this.settings.type == 'heatmap') {
        // console.log('heatmap', polygon.data[1])
        if(!polygon.data) { 
          color = 'url(#nodata)'
          // console.log(polygon)
        }
        else {
          color = this.colorScale(polygon.data[1])||'url(#nodata)'
        }
      }
      else if (this.settings.type == 'category') {
        // console.log('categry')
        if(polygon.data.category == 'nodata') {
          color = 'url(#nodata)'
        }
        if(this.settings.colors) {
          // console.log("fuck")
          let match = this.settings.colors.find(party => party.id == polygon.data.category)
          color = match ? match.color : 'url(#nodata)'
        } else {
          color = 'url(#nodata)'
        }

        
        // return this.settings.colors.find(party => party.label == polygon.data.category).color||'#efefef'
      }
      return color
    },
    mouseover (polygon) {
      let centroid = this.path.centroid(polygon.feature)
      // console.log(polygon)

      this.hover = {
        region: polygon.feature.properties[this.settings.regionLabel],
        value: polygon.data[1],
        x: this.clamp(Math.round(centroid[0]), 60, this.width-60),
        y: this.clamp(Math.round(centroid[1]), 60, this.height),
        path: this.path(polygon.feature)
      }
    },
    clamp (num, min, max) {
      return num <= min ? min : num >= max ? max : num;
    },
    mouseleave () {
      this.hover = null
    },
    selectRegion (polygon) {
      this.$emit('input', {
        id: polygon.data.regionKey,
        name: polygon.data.regionName
      })
    },
    resetRegion () {
      this.$emit('input', {
        id: 0,
        name: 'Wahlkreis suchen'
      })
    },
    cssGradient (colors) {
      return `background: linear-gradient(90deg, ${colors[0]} 0%, ${colors[1]} 100%);`
    }
  },
  updated () {
  },
  mounted () {
    this.fitProjection()
    window.addEventListener('resize', debounce(this.fitProjection, 250))

    // this.data.forEach(row => {
    //   let match = this.geoJson.features.find( feature => feature.properties.AGS == row.regionKey)
    //   if(!match) {
    //     console.log(row)
    //   }
    // })
  },
  watch: {
    data: function () {
      this.fitProjection()
    },
    // zoomLevel: function () {
    //   if (this.zoomLevel<1.1) {
    //     this.panEnabled = false
    //   } else {
    //     this.panEnabled =  true
    //     this.registerSvgPanZoom()
    //   }
    // }
  },
  computed: {
    settings: function () {
      return Object.assign(this.defaultOptions, this.options)
    },
    path () {
      return d3.geoPath().projection(this.projection)
    }
  }
}
</script>

<style scoped lang='scss'>
.choropleth {
  box-sizing: border-box;
  position: relative;
  // width: 100%;

  .mapWrapper {
    position: relative;
  }

  .map {
    .polygon {
      stroke: #fff;
      fill: rgba(255,255,255,.66);
      stroke-width: .5;
      filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
    }

    .marker-dot {
      pointer-events: none;
      fill: #000;
      stroke: #fff;
    }

    .marker {
      pointer-events: none;
      // font-weight: bold;
      font-family: 'FAZ Gold', Helvetica, Arial, sans-serif;
      // text-anchor: middle;
      font-size: 14px;
      fill: #fff;

      &.shaddow {
        fill: rgba(17,17,17,1);
        stroke: rgba(17,17,17,1);
        // stroke-width: 2;
      }
    }
  }
}
</style>